"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLazyLoadElement = exports.useTimer = exports.useMediaQuery = exports.useTheme = exports.useEventListener = exports.useInterval = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _styledComponents = require("styled-components");

var useInterval = function useInterval(callback, delay) {
  var savedCallback = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]);
  (0, _react.useEffect)(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }

    return true;
  }, [delay]);
};

exports.useInterval = useInterval;

var useEventListener = function useEventListener(JobName, handler) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  var savedHandler = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    savedHandler.current = handler;
  }, [handler]);
  (0, _react.useEffect)(function () {
    var isSupported = element && element.addEventListener;
    if (!isSupported) return;

    var JobListener = function JobListener(Job) {
      return savedHandler.current(Job);
    };

    element.addEventListener(JobName, JobListener);
    return function () {
      element.removeEventListener(JobName, JobListener);
    };
  }, [JobName, element]);
};

exports.useEventListener = useEventListener;

var useTheme = function useTheme() {
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  return theme;
};

exports.useTheme = useTheme;

var useMediaQuery = function useMediaQuery(queryInput) {
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      match = _useState2[0],
      setMatch = _useState2[1];

  var types = ['mobile', 'tables', 'desktop', 'wideScreen'];

  if (!types.includes(queryInput)) {
    return undefined;
  }

  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var mediaQueries = theme.mediaQueries;
  var query = mediaQueries[queryInput];
  query = query.replace(/^@media( ?)/m, '');
  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  (0, _react.useEffect)(function () {
    var active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    var queryList = window.matchMedia(query);

    var updateMatch = function updateMatch() {
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch();
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, supportMatchMedia]);
  return match;
};

exports.useMediaQuery = useMediaQuery;

var useTimer = function useTimer(_ref) {
  var initialTime = _ref.initialTime;

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      time = _useState4[0],
      setTime = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      timeInterval = _useState6[0],
      setTimeInterval = _useState6[1];

  var getFormattedTime = function getFormattedTime() {
    if (typeof time !== 'number') {
      return '';
    }

    var hours = Math.floor(time / 3600);
    var minutes = Math.floor((time - hours * 3600) / 60);
    var seconds = time - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = "0".concat(hours);
    }

    if (minutes < 10) {
      minutes = "0".concat(minutes);
    }

    if (seconds < 10) {
      seconds = "0".concat(seconds);
    }

    return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
  };

  (0, _react.useEffect)(function () {
    if (initialTime) {
      if (timeInterval) {
        clearInterval(timeInterval);
      }

      var now = new Date().getTime();
      var initialTimeDate = new Date(initialTime);
      var timeDiff = parseInt((now - initialTimeDate) / 1000, 10);
      setTime(timeDiff);
      setTimeInterval(setInterval(function () {
        setTime(function (currentTime) {
          return currentTime + 1;
        });
      }, 1000));
    }

    return function () {
      if (timeInterval) {
        clearInterval(timeInterval);
      }
    };
  }, [initialTime]);
  return {
    time: getFormattedTime()
  };
};

exports.useTimer = useTimer;

var useLazyLoadElement = function useLazyLoadElement(_ref2) {
  var lazyLoading = _ref2.lazyLoading,
      rootElement = _ref2.rootElement,
      rootMargin = _ref2.rootMargin;

  var _useState7 = (0, _react.useState)(!lazyLoading),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      isElementVisible = _useState8[0],
      setElementVisible = _useState8[1];

  var finishedLazyLoading = (0, _react.useRef)(false);
  var elementObserverRef = (0, _react.useRef)(null);

  var getElementRef = function getElementRef(node) {
    if (!node) {
      return;
    }

    if (!lazyLoading || finishedLazyLoading.current === true) {
      return;
    }

    if (elementObserverRef.current) {
      return;
    }

    var observer = new IntersectionObserver(function (_ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
          entry = _ref4[0];

      if (entry.isIntersecting) {
        setElementVisible(true);
        observer.disconnect();
        elementObserverRef.current = null;
        finishedLazyLoading.current = true;
      }
    }, {
      root: rootElement,
      rootMargin: rootMargin
    });
    elementObserverRef.current = observer;
    observer.observe(node);
  };

  return {
    isElementVisible: isElementVisible,
    getElementRef: getElementRef
  };
};

exports.useLazyLoadElement = useLazyLoadElement;